export default function ({ query, $axios }) {
  if (query.preview) {
    // set header for preview
    $axios.defaults.headers.common.preview = query.preview
  } else if ($axios?.defaults?.headers?.common?.preview) {
    // disable preview
    delete $axios.defaults.headers.common.preview
  }
}
